<template>
  <div v-click-outside="hide">
    <button class="btn white --sm mr-2" @click="show">
      {{ selectedDisplay }}
    </button>
    <div class="_rel">
      <div
        v-show="monthSelectVisible"
        class="month-input__container elevation-1 py-1 px-1 mt-1"
      >
        <div class="month-input">
          <ul class="dropdown" :style="{columns:selectableMonthscolumns}">
            <li tabindex="0"
              v-for="(monthMoment, index) in selectableMonths"
              :key="index"
              class="btn btn-link --sm month-input__month"
              active
              @click="select(monthMoment)"
            >
              {{ monthMoment }}
            </li>
          </ul>
        </div>
        <div class="month-input__footer mt-2">
          <div class="clear">
            <a @click="clear" href="javascript:void(0)">
              Clear
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    props: {
      value: {
        type: [String, Date],
        default: () => null
      },
      /**
       * Can be an array of date strings or js Dates
       */
      months: {
        type: Array,
        default() {
          return [
            'Dec 2020',
            'Jan 2021',
            'Mar 2021',
            'Apr 2021',
            'May 2021',
            'Jun 2021',
            'Aug 2021',
            'Sep 2021'
          ]
        }
      },
      placeholder: {
        type: String,
        default() {
          return 'Months'
        }
      },
      format: {
        type: String,
        default() {
          return 'MMM YYYY'
        }
      },
      // allow changing color
      variant: {}
    },
    data() {
      return {
        monthSelectVisible: false
      }
    },
    computed: {
      selectableMonths() {
        return [...new Set(this.months.map(x => moment(x).format(this.format)))]
      },
      selectedDisplay() {
        return this.value
          ? moment(this.value, this.format).format(this.format)
          : this.placeholder
      },
      selectableMonthscolumns() {
        const maxColumns = 4
        let columns = Math.ceil(this.selectableMonths.length / 10)
        return columns > maxColumns ? maxColumns : columns
      }
    },
    methods: {
      show() {
        this.monthSelectVisible = true
      },
      hide() {
        this.monthSelectVisible = false
      },
      select(monthMoment) {
        this.$emit('input', monthMoment)
        this.hide()
      },
      clear() {
        this.$emit('input', null)
        this.hide()
      }
    }
  }
</script>

<style lang="scss" scoped>
button {
  width: 120px;
}

.month-input__container {
  // width: 386px;
  position: absolute;
  background: white;
  z-index: 1000;
}

.month-input {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-height: 450px;
  overflow-y: auto;

  .dropdown{
    padding: 0.2rem;
  }
  .month-input__month {
    // flex-basis: calc(33.333% - 10px);
    margin: 2px;
  }
}

.month-input__footer {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
